import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/compat/database';
import { UserState, Vehicule } from '@client/utils/shared-constants';
import { EMPTY, Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Injectable()
export class UserVehiclesService {
	itemsRef: AngularFireList<UserState> | Observable<never>;

	constructor(private db: AngularFireDatabase, private auth: AngularFireAuth) {
		auth.authState
			.pipe(
				tap(u => {
					this.itemsRef = u ? this.db.list<UserState>(`/user/${u.uid}/vehicles`) : EMPTY;
				})
			)
			.subscribe();
	}

	hydrate() {
		return this.auth.user.pipe(switchMap(u => (u ? this.db.object<Vehicule[]>(`/user/${u.uid}/vehicles`).valueChanges() : EMPTY)));
	}
}
